/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListUnitsParams,
  PaginatedUnitOut,
  UnitIn,
  UnitOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listUnitsResponse200 = {
  data: PaginatedUnitOut
  status: 200
}

export type listUnitsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listUnitsResponseSuccess = (listUnitsResponse200) & {
  headers: Headers;
};
export type listUnitsResponseError = (listUnitsResponse422) & {
  headers: Headers;
};

export type listUnitsResponse = (listUnitsResponseSuccess | listUnitsResponseError)

export const getListUnitsUrl = (params?: ListUnitsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/units?${stringifiedParams}` : `/api/units`
}

/**
 * @summary List Units
 */
export const listUnits = async (params?: ListUnitsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listUnitsResponse> => {

  return apiFetch<listUnitsResponse>(getListUnitsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUnitsQueryKey = (params?: ListUnitsParams,) => {
    return [
    `/api/units`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUnitsQueryOptions = <TData = Awaited<ReturnType<typeof listUnits>>, TError = HTTPValidationError>(params?: ListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUnitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnits>>> = ({ signal }) => listUnits(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof listUnits>>>
export type ListUnitsQueryError = HTTPValidationError


export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = HTTPValidationError>(
 params: undefined |  ListUnitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnits>>,
          TError,
          Awaited<ReturnType<typeof listUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = HTTPValidationError>(
 params?: ListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnits>>,
          TError,
          Awaited<ReturnType<typeof listUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = HTTPValidationError>(
 params?: ListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Units
 */

export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = HTTPValidationError>(
 params?: ListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createUnitResponse201 = {
  data: UnitOut
  status: 201
}

export type createUnitResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createUnitResponseSuccess = (createUnitResponse201) & {
  headers: Headers;
};
export type createUnitResponseError = (createUnitResponse422) & {
  headers: Headers;
};

export type createUnitResponse = (createUnitResponseSuccess | createUnitResponseError)

export const getCreateUnitUrl = () => {




  return `/api/units`
}

/**
 * @summary Create Unit
 */
export const createUnit = async (unitIn: UnitIn, options?: Parameters<typeof apiFetch>[1]): Promise<createUnitResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createUnitResponse>(getCreateUnitUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unitIn)
  }
);}





export const getCreateUnitMutationKey = () => ['createUnit'] as const;

export const getCreateUnitMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,CreateUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,CreateUnitMutationVariables, TContext> => {

const mutationKey = getCreateUnitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUnit>>, CreateUnitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUnit(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof createUnit>>>
    export type CreateUnitMutationBody = UnitIn
    export type CreateUnitMutationError = HTTPValidationError
    export type CreateUnitMutationVariables = {data: UnitIn}

    /**
 * @summary Create Unit
 */
export const useCreateUnit = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,CreateUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUnit>>,
        TError,
        CreateUnitMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUnitMutationOptions(options), queryClient);
    }
    export type getUnitResponse200 = {
  data: UnitOut
  status: 200
}

export type getUnitResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getUnitResponseSuccess = (getUnitResponse200) & {
  headers: Headers;
};
export type getUnitResponseError = (getUnitResponse422) & {
  headers: Headers;
};

export type getUnitResponse = (getUnitResponseSuccess | getUnitResponseError)

export const getGetUnitUrl = (recordId: number,) => {




  return `/api/units/${recordId}`
}

/**
 * @summary Get Unit
 */
export const getUnit = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getUnitResponse> => {

  return apiFetch<getUnitResponse>(getGetUnitUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnitQueryKey = (recordId: number,) => {
    return [
    `/api/units/${recordId}`
    ] as const;
    }


export const getGetUnitQueryOptions = <TData = Awaited<ReturnType<typeof getUnit>>, TError = HTTPValidationError>(recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnitQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnit>>> = ({ signal }) => getUnit(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnitQueryResult = NonNullable<Awaited<ReturnType<typeof getUnit>>>
export type GetUnitQueryError = HTTPValidationError


export function useGetUnit<TData = Awaited<ReturnType<typeof getUnit>>, TError = HTTPValidationError>(
 recordId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnit>>,
          TError,
          Awaited<ReturnType<typeof getUnit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnit<TData = Awaited<ReturnType<typeof getUnit>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnit>>,
          TError,
          Awaited<ReturnType<typeof getUnit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnit<TData = Awaited<ReturnType<typeof getUnit>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Unit
 */

export function useGetUnit<TData = Awaited<ReturnType<typeof getUnit>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnitQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateUnitResponse200 = {
  data: UnitOut
  status: 200
}

export type updateUnitResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateUnitResponseSuccess = (updateUnitResponse200) & {
  headers: Headers;
};
export type updateUnitResponseError = (updateUnitResponse422) & {
  headers: Headers;
};

export type updateUnitResponse = (updateUnitResponseSuccess | updateUnitResponseError)

export const getUpdateUnitUrl = (recordId: number,) => {




  return `/api/units/${recordId}`
}

/**
 * @summary Update Unit
 */
export const updateUnit = async (recordId: number,
    unitIn: UnitIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateUnitResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateUnitResponse>(getUpdateUnitUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unitIn)
  }
);}





export const getUpdateUnitMutationKey = () => ['updateUnit'] as const;

export const getUpdateUnitMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,UpdateUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,UpdateUnitMutationVariables, TContext> => {

const mutationKey = getUpdateUnitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUnit>>, UpdateUnitMutationVariables> = (props) => {
          const {recordId,data} = props ?? {};

          return  updateUnit(recordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof updateUnit>>>
    export type UpdateUnitMutationBody = UnitIn
    export type UpdateUnitMutationError = HTTPValidationError
    export type UpdateUnitMutationVariables = {recordId: number;data: UnitIn}

    /**
 * @summary Update Unit
 */
export const useUpdateUnit = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,UpdateUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUnit>>,
        TError,
        UpdateUnitMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUnitMutationOptions(options), queryClient);
    }
    export type deleteUnitResponse204 = {
  data: void
  status: 204
}

export type deleteUnitResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteUnitResponseSuccess = (deleteUnitResponse204) & {
  headers: Headers;
};
export type deleteUnitResponseError = (deleteUnitResponse422) & {
  headers: Headers;
};

export type deleteUnitResponse = (deleteUnitResponseSuccess | deleteUnitResponseError)

export const getDeleteUnitUrl = (recordId: number,) => {




  return `/api/units/${recordId}`
}

/**
 * @summary Delete Unit
 */
export const deleteUnit = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteUnitResponse> => {

  return apiFetch<deleteUnitResponse>(getDeleteUnitUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUnitMutationKey = () => ['deleteUnit'] as const;

export const getDeleteUnitMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,DeleteUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,DeleteUnitMutationVariables, TContext> => {

const mutationKey = getDeleteUnitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUnit>>, DeleteUnitMutationVariables> = (props) => {
          const {recordId} = props ?? {};

          return  deleteUnit(recordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUnitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnit>>>

    export type DeleteUnitMutationError = HTTPValidationError
    export type DeleteUnitMutationVariables = {recordId: number}

    /**
 * @summary Delete Unit
 */
export const useDeleteUnit = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,DeleteUnitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUnit>>,
        TError,
        DeleteUnitMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUnitMutationOptions(options), queryClient);
    }
